// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextFieldsOutlinedIcon from '@material-ui/icons/TextFieldsOutlined';
import { withTranslation } from 'react-i18next';
import { ListItemIcon, Tooltip, withTheme, ListItem, ListItemText, Slider } from '@material-ui/core';
import RemoveOutlinedIcon from '@material-ui/icons/RemoveOutlined';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';

const styles = {
  root: {
    width: '150px',
  },
  avaSlider: {
    '& .MuiSlider-thumb': {
      backgroundColor: '#50aced',
      '&:hover': {
        boxShadow: '0px 0px 0px 8px rgba(80, 172, 237, 15%)',
        '&.MuiSlider-active': {
          boxShadow: '0px 0px 0px 14px rgba(80, 172, 237, 15%)',
        },
      },
    },
    '& .MuiSlider-rail': {
      backgroundColor: 'rgba(80, 172, 237, 65%)',
    },
    '& .MuiSlider-track': {
      backgroundColor: '#50aced',
    },
  },
};

type State = { preview: boolean };

type Props = {
  classes: Object,
  fontSize: number,
  scribeSetFontSizeAndSave: Function,
  t: Function,
  theme: Object,
};

class ScribeFontSizeInput extends React.Component<Props, State> {
  timeout;

  constructor(props) {
    super(props);
    this.state = {
      preview: false,
    };
  }

  scribeSetFontSizeAndSave(data: { ratio: number } | { fontSize: number }) {
    const { scribeSetFontSizeAndSave, fontSize } = this.props;
    // $FlowFixMe
    const newFontSize = data.fontSize || Math.round(fontSize * data.ratio);
    scribeSetFontSizeAndSave(newFontSize);
    clearTimeout(this.timeout);
    if (window.navigator.share) {
      this.timeout = setTimeout(() => this.setState({ preview: false }), 1000);
      this.setState({ preview: true });
    }
  }

  render() {
    const { fontSize, t, theme, classes } = this.props;
    const { preview } = this.state;
    const logFontSize = Math.log10(fontSize);
    return (
      <>
        <ListItem
          style={{
            zIndex: 0,
            paddingLeft: 32,
          }}
        >
          <ListItemIcon>
            <TextFieldsOutlinedIcon />
          </ListItemIcon>
          <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            <ListItemText>{t('editorSettings.fontSize')}</ListItemText>
            <div
              style={{
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Tooltip title={t('theme.decreaseFontSize')}>
                <ListItemIcon
                  onClick={() => this.scribeSetFontSizeAndSave({ ratio: 0.93 })}
                  style={{
                    color: theme.palette.contrast[theme.palette.type],
                    cursor: 'pointer',
                    opacity: 0.9,
                    marginRight: 12,
                    minWidth: 0,
                  }}
                >
                  <RemoveOutlinedIcon />
                </ListItemIcon>
              </Tooltip>
              <Slider
                style={{
                  flexGrow: 1,
                }}
                className={classes.avaSlider}
                value={logFontSize}
                onChange={(e, v) => this.scribeSetFontSizeAndSave({ fontSize: 10 ** v })}
                min={1}
                max={2.2}
                step={0.05}
              />
              <Tooltip title={t('theme.increaseFontSize')}>
                <ListItemIcon
                  onClick={() => this.scribeSetFontSizeAndSave({ ratio: 1.1 })}
                  style={{
                    color: theme.palette.contrast[theme.palette.type],
                    cursor: 'pointer',
                    opacity: 0.9,
                    marginRight: 0,
                    marginLeft: 12,
                    minWidth: 0,
                  }}
                >
                  <AddOutlinedIcon />
                </ListItemIcon>
              </Tooltip>
            </div>
          </div>
        </ListItem>
        <div
          style={{
            fontSize,
            position: 'absolute',
            backgroundColor: theme.palette.primary[theme.palette.type],
            zIndex: preview ? 1 : -1,
            padding: 10,
            width: '100%',
            left: 0,
            color: theme.palette.contrast[theme.palette.type],
            WebkitTransition: 'opacity 0.5s ease-in',
            MozTransition: 'opacity 0.5s ease-in',
            MsTransition: 'opacity 0.5s ease-in',
            OTransition: 'opacity 0.5s ease-in',
            transition: 'opacity 0.5s ease-in',
            textAlign: 'center',
            opacity: preview ? 0.9 : 0,
          }}
        >
          <span>{t('theme.example')}</span>
        </div>
      </>
    );
  }
}

export default withTranslation()(withTheme(withStyles(styles)(withTheme(ScribeFontSizeInput))));
